angular.module("core").constant(
    "SETVALIDITY_DIGEST_TIMEOUT_DELAY", 500
);



//////////////////
// WEBPACK FOOTER
// ./core/form-error/form-error.constant.js
// module id = 386
// module chunks = 0